/* projects/speaker-platform/src/app/atoms/daily-status/daily-status.component.scss */
.dailystatus {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.dailystatus__day {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 700;
}
.dailystatus__status {
  font-size: 23px;
}
.dailystatus__status--SEANCE {
  color: #289526;
}
.dailystatus__status--NO_SEANCE,
.dailystatus__status--PUBLIC_HOLIDAY {
  color: #575757;
}
.dailystatus__status--MALADE {
  color: #952626;
}
.dailystatus__status--ABSENCE {
  color: #9A7407;
}
.dailystatus__status--STUDIO {
  color: #dadada;
}
/*# sourceMappingURL=daily-status.component-VVERN776.css.map */
